<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">사용자관리</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
            <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteRowd">삭제</el-button>
            <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 검색조건 영역 -->
      <div class="search-form" style=" width: 100%; border: unset; background: unset;">
        <el-form size="mini" label-width="80px">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="5">
              <el-form-item label="사용자명">
                <el-input type="text" v-model="form.userNm"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 테이블 -->
      <div class="talbe-contain" style="display: flex;">
        <div class="table-area" style="margin-right: 50px; width: 30%;">
          <div class="table-b">
            <ag-grid-vue
                ref="gridSub"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadySub"
                @cell-clicked="onCellClickedSub"
            />
          </div>
        </div>
        <div class="table-area" style="width: 70%;">
          <user-info ref="userInfo"  :userDetail="userDetail" :parentNm="parentNm" style="height: 80%; margin-left: 10px;"/>
        </div>
      </div> <!-- table contain -->
    </div>
  </div>

</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import userInfo from '@/components/InfoManage/UserInfo/UserInfo.vue';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "userMng",
  components: {userInfo},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      rowData: "",
      form: {
        addr1: "",
        addr2: "",
        asAgentId:"",
        asAgentNm: "",
        companyId: "",
        createDt: "",
        creatorId: "",
        ctiId: "",
        ctiPwd: "",
        ctiStation: "",
        ctiYn: "",
        deleteYn: "",
        deptId: "",
        description: "",
        dutyId: "",
        email: "",
        emailYn: "",
        enterDt: "",
        erpId: "",
        erpPwd: "",
        faxNo: "",
        groupUid: "",
        hpNo: "",
        juminNo: "",
        loginYn: "",
        pictureUrl: "",
        retireDt: "",
        telNo: "",
        updateDt: "",
        updatorId: "",
        useYn: "",
        userCd: "",
        userId: "",
        userNm: "",
        userPwd:"",
        zipCd: ""
      },
      defForm: {
        addr1: "",
        addr2: "",
        asAgentId:"",
        asAgentNm: "",
        companyId: "",
        createDt: "",
        creatorId: "",
        ctiId: "",
        ctiPwd: "",
        ctiStation: "",
        ctiYn: "",
        deleteYn: "",
        deptId: "",
        description: "",
        dutyId: "",
        email: "",
        emailYn: "",
        enterDt: "",
        erpId: "",
        erpPwd: "",
        faxNo: "",
        groupUid: "",
        hpNo: "",
        juminNo: "",
        loginYn: "",
        pictureUrl: "",
        retireDt: "",
        telNo: "",
        updateDt: "",
        updatorId: "",
        useYn: "",
        userCd: "",
        userId: "",
        userNm: "",
        userPwd:"",
        zipCd: "",
        parentId: "",
        chk1: false,
        chk2: false,
        agYn: "N",
        agMaker: "",
        agMakerNm: ""
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      userDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
      searchNm : "",
      gridStyle : 'padding-top: 0px; width: 100%;height: 97vh; min-height:100px;',
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      this.gridApiSub.sizeColumnsToFit();

      this.$store.commit('loading')
      this.$http
          .post("/api/userMng/user/list", {
            companyId: this.$store.state.loginInfo.compCd,
            groupUid : 0,
            userNm : this.form.userNm,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.cancel();
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indiusere if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {headerName:'이름', field:'userNm', headerClass: 'require-column', width:80, editable:false},
        {headerName:'ID', field:'userCd', headerClass: 'require-column', width:50, editable:false},
        {
          headerName: '재직'
          , field:'useYn'
          , width : 15
          , editable: false
          , cellRenderer: 'checkboxRenderer'
          , cellRendererParams: {
            trueValue: "Y"    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: "N"  //false값 지정 defalut-"N" ex) "N", false, "0"
            , readonly: true // 수정 불가능하도록
          },
        },
      ]
    },
    //Main 그리드 SelctionChange 발생
    onSelectionChangedMain(event) {
      const voRow = this.gridApi.getSelectedRows() //선택된 Row
      this.userDetail = this.defForm;
      this.parentNm = voRow[0].menu_nm;
      this.$store.commit('loading')
      this.$http
          .post("/api/userMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            parentId: voRow[0].menu_id,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.selectId = voRow[0].menu_id;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    onCellClickedSub(params) {
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      this.$refs.userInfo.form = _.clone(this.defForm);
      const voRow = params.data //선택된 Row
      this.rowData = params.data;
      this.$http
          .post("/api/userMng/user/info", {
            companyId: this.$store.state.loginInfo.compCd,
            userId: voRow.userId,
            processTime : ""
          })
          .then(response => {
            if(response.data[0]){
              this.userDetail = response.data[0];
            }
          }).finally(() => {
      });
    },
    goOpen() {

      this.$store.commit('loading')
      this.$http
          .post("/api/userMng/user/list", {
            companyId: this.$store.state.loginInfo.compCd,
            groupUid : 0,
            userNm : this.form.userNm,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.cancel();
          }).finally(() => {
        this.$store.commit('finish')
      });


    },
    save() {
      const userInfo = JSON.parse(JSON.stringify(this.$refs.userInfo.form));
      if(!this.gridRequireCheck([this.$refs.gridSub ])) return;
      const $this = this;


      //상세코드 확인
      if(userInfo.userCd == ""){
        this.$swal({type: 'warning', text: '유저 아이디는 필수 입력 사항입니다.'});
        return false;
      }else if(userInfo.userPwd == ""){
        this.$swal({type: 'warning', text: '유저 비밀번호는 필수 입력 사항입니다.'});
        return false;
      }else if(userInfo.userNm == ""){
        this.$swal({type: 'warning', text: '유저 이름은 필수 입력 사항입니다.'});
        return false;
      }else if(userInfo.enterDt == "") {
        this.$swal({type: 'warning', text: '입사일자는 필수 입력 사항입니다.'});
        return false;
      }else if(userInfo.groupUid == "") {
        this.$swal({type: 'warning', text: '보안그룹은 필수 입력 사항입니다.'});
        return false;
      }

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(userInfo.userId == ""){
        let maxIdx = 0;

        for (var i = 0; this.subData.length > i ; i++){
          if(this.subData[i].userIdx > maxIdx) maxIdx = this.subData[i].userIdx;
        }

        //저장 시작
        //userMng
        this.$http
            .put('/api/userMng/user/save',{
              companyId: this.$store.state.loginInfo.compCd,
              userCd: userInfo.userCd,
              userPwd: userInfo.userPwd,
              userNm: userInfo.userNm,
              zipCd: userInfo.zipCd,
              addr1: userInfo.addr1,
              addr2: userInfo.addr2,
              email: userInfo.email,
              emailYn: userInfo.emailYn,
              loginYn: userInfo.loginYn,
              groupUid: userInfo.groupUid,
              description: userInfo.description,
              pictureUrl : userInfo.pictureUrl,
              creatorId: this.$store.state.loginInfo.id,
              agYn : userInfo.agYn,
              agMaker : userInfo.agMaker == "" ? 0 : userInfo.agMaker,
              processTime: "",
            })
            .then(response => {
              const userId = response.data;
              //userEmp
              this.$http
                  .put('/api/userMng/userEmp/save',{
                    companyId: $this.$store.state.loginInfo.compCd,
                    userId: userId,
                    deptId: this.isEmpty(userInfo.deptId) == "" ? 0 : userInfo.deptId,
                    // asAgentId : userInfo.asAgentId, 추후 프러퍼티에 숫자 1 넣을것
                    asAgentId : 3,
                    juminNo: userInfo.juminNo,
                    dutyId : userInfo.dutyId,
                    // enterDt: userInfo.enterDt,
                    enterDt: userInfo.enterDt,
                    // StringRetireDt: userInfo.retireDt,
                    retireDt: "",
                    ctiYn: userInfo.ctiYn,
                    ctiId: userInfo.ctiId,
                    ctiPwd: userInfo.ctiPwd,
                    ctiStation: userInfo.ctiStation,
                    erpId: userInfo.erpId,
                    erpPwd: userInfo.erpPwd,
                    telNo: userInfo.telNo,
                    hpNo: userInfo.hpNo,
                    faxNo: userInfo.faxNo,
                    useYn: userInfo.useYn,
                    creatorId: $this.$store.state.loginInfo.id,
                    processTime: "",
                  })
                  .then(response => {
                    this.$http
                        .put('/api/userMng/Auser/save',{
                          userCd: userInfo.userCd,
                          userNm: userInfo.userNm,
                          groupUid: userInfo.groupUid,
                        })
                        .then(response => {
                          this.$swal({ type: 'success', text: '저장되었습니다.' });
                          this.goOpen();
                        })
                        .catch(e => {
                          this.$swal({type: 'error', text: e.response.data.message});
                          return e;
                        });
                  })
                  .catch(e => {
                    this.$swal({type: 'error', text: e.response.data.message});
                    return e;
                  });

            })
            .catch(e => {
              this.$swal({type: 'error', text: e.response.data.message});
              return e;
            });
      }else{
        //수정 시작
        //userMng
        this.$http
            .put('/api/userMng/user/update',{
              companyId: this.$store.state.loginInfo.compCd,
              userId: userInfo.userId,
              userCd: userInfo.userCd,
              userNm: userInfo.userNm,
              zipCd: userInfo.zipCd,
              addr1: userInfo.addr1,
              addr2: userInfo.addr2,
              email: userInfo.email,
              emailYn: userInfo.emailYn,
              loginYn: userInfo.loginYn,
              groupUid: userInfo.groupUid,
              description: userInfo.description,
              pictureUrl : userInfo.pictureUrl,
              updatorId: this.$store.state.loginInfo.id,
              agYn : userInfo.agYn,
              agMaker : userInfo.agMaker == "" ? 0 : userInfo.agMaker,
              processTime: "",
            })
            .then(response => {
              //userEmp
              this.$http
                  .put('/api/userMng/userEmp/update',{
                    companyId: $this.$store.state.loginInfo.compCd,
                    userId: userInfo.userId,
                    deptId: this.isEmpty(userInfo.deptId) == "" ? 0 : userInfo.deptId,
                    asAgentId : 3,
                    juminNo: userInfo.juminNo,
                    dutyId : userInfo.dutyId,
                    // enterDt: userInfo.enterDt,
                    enterDt: userInfo.enterDt,
                    // StringRetireDt: userInfo.retireDt,
                    // retireDt: userInfo.retireDt,
                    retireDt: userInfo.retireDt,
                    ctiYn: userInfo.ctiYn,
                    ctiId: userInfo.ctiId,
                    ctiPwd: userInfo.ctiPwd,
                    ctiStation: userInfo.ctiStation,
                    zipCd: userInfo.zipCd,
                    erpId: userInfo.erpId,
                    erpPwd: userInfo.erpPwd,
                    telNo: userInfo.telNo,
                    hpNo: userInfo.hpNo,
                    faxNo: userInfo.faxNo,
                    useYn: userInfo.useYn,
                    updatorId: $this.$store.state.loginInfo.id,
                    processTime: "",
                  })
                  .then(response => {
                    this.$swal({ type: 'success', text: '수정되었습니다.' });
                    this.goOpen();
                  })
                  .catch(e => {
                    this.$swal({type: 'error', text: e.response.data.message});
                    return e;
                  });

            })
            .catch(e => {
              console.log(e.response);
              this.$swal({type: 'error', text: e.response.data.message});
              return e;
            });
      }

    },
    saveIdx() {

      let subData = this.$refs.gridSub.rowData;
      try {
        for(var i=0; subData.length; i++){
          this.$http
              .put('/api/userMng/update/idx',{
                companyId: this.$store.state.loginInfo.compCd,
                userId: subData[i].userId,
                userIdx: subData[i].userIdx,
                updatorId: this.$store.state.loginInfo.id, // 추후 로그인 id 넣을것
                processTime: ""
              })
              .then(response => {

              })
              .catch(({ message }) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({ type: "error", text: "오류가 발생했습니다." });
                }
              });
        }
      }catch (e){
        this.$swal({
          type: 'error',
          text: '오류가 발생했습니다.'
        })
      }
      this.$swal({ type: 'success', text: '수정되었습니다.' });
      this.goOpen();

    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    addRow() {
      this.data.push({
        groupCd: "",
        groupNm: "",
        useYn: "Y",
        groupDesc: "",
        compCd: this.$store.state.loginInfo.compCd,
      });
    },
    deleteRowd() {
      try{

        const row = this.rowData;

        if(this.rowData == "")
          throw '선택된 사용자가 없습니다.'

        let userId =  parseInt(row.userId);
        let userCd =  row.userCd;
        let updatorId = this.$store.state.loginInfo.id;
        let compCd =  this.$store.state.loginInfo.compCd;

        this.$swal({
          type: 'info',
          text: `선택한 유저를 삭제 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
        }).then((result) => {
          if (result.value) {
            this.$store.commit('loading')
            this.$http.delete(_url("/api/userMng/user/delete/" + (compCd) + "/" + (userId) + "/" + (updatorId) + "/" +  userCd), {
              process_time: ""
            }).then(response => {
              this.$swal({type: 'success', text: '삭제 되었습니다.'});
              this.goOpen();
            })
            .catch((e) => {
              this.$swal({type: 'error', text: e.response.data.message});
            }).finally(() => {
              this.$store.commit('finish');
            });
          }

        });




      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    addRowd() {
      try{

        const row = this.gridApi.getSelectedNodes()

        if(row.length < 1)
          throw '그룹코드가 선택되지 않았습니다.'

        const idx = row[0].rowIndex

        this.subData.push({
          detailCd: "",
          detailNm: "",
          useYn: "Y",
          orderSeq: "",
          remark1: "",
          remark2: "",
          remark3: "",
          remark4: "",
          remark5: "",
          detailDesc: "",
          parent_id: this.data[0].inner_menu[idx-1].parent_id,
          compCd: this.$store.state.loginInfo.compCd,
        });
      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    },
    cancel(){
      // userInfo 초기화
      this.$refs.userInfo.form = _.clone(this.defForm);
    },
    search(){

      this.$store.commit('loading')
      this.$http
          .post("/api/userMng/user/list", {
            companyId: this.$store.state.loginInfo.compCd,
            groupUid : 0,
            userNm : this.form.userNm,
            sortType : true,
            page : 1,
            totalPage : 9999,
            totalCount : 9999,
            curPage : 0,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data
            this.cancel();
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  group:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          //console.log('ServerSideDatasource.getRows: params = ', params);

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
};

</script>